<template>
	<div>
		<div  v-loading="loading"  class="contact_box min_he200">
			<div class="contact_company">
				<div class="tech_title">东仁化学科技（上海）有限公司</div>
				<!-- <div class="asdhju">联系方式:
					<span class="iconfont icon-dainhau"></span>021-6427-2302
					<span class="iconfont icon-xinxi"></span>info@dojindo.cn
				</div> -->
				<div v-html="contact.contact_us1">
				</div>
				<!-- <div>
					公司地址：上海市零陵路899号飞洲国际广场27楼J座
				</div>
				<div>
					订货时间：工作日8:30-17:30
				</div> -->

				<div class="contact_btn laing_btn" @click="xin.goNew('tencent://message/?uin=3518162518')">
						<i class="iconfont icon-qq"></i>3518162518
				</div>
			</div>
			<div class="contact_company">
				<div class="tech_title">北仁化学科技（北京）有限公司</div>
				<!-- <div class="asdhju">联系方式:
					<span class="iconfont icon-dainhau"></span>010-8225-1765
					<span class="iconfont icon-xinxi"></span>info@dojindo.cn
				</div> -->
				<div v-html="contact.contact_us2">
				</div>
				<!-- <div>
					公司地址：北京市朝阳区德外马甸裕民路12号元辰鑫大厦E1-210室
				</div>
				<div>
					订货时间：工作日8:30-17:30
				</div> -->
				<div class="contact_btn laing_btn" @click="xin.goNew('tencent://message/?uin=3278165235')">
						<i class="iconfont icon-qq"></i>3278165235
				</div>
			</div>
		</div>
		<p class="tech_titleas">请让我们知道您的问题，我们会尽快回复您</p>
		<div class="contact_form">
			<el-form   label-position="left" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
				<el-form-item label="姓名" prop="name">
					<el-input v-model="ruleForm.name"></el-input>
				</el-form-item>
				<el-form-item label="单位" prop="unit">
					<el-input v-model="ruleForm.unit"></el-input>
				</el-form-item>
				<el-form-item label="地址" prop="address">
					<el-input v-model="ruleForm.address"></el-input>
				</el-form-item>
				<el-form-item label="专业" prop="specialty">
					<el-input v-model="ruleForm.specialty"></el-input>
				</el-form-item>
				<el-form-item label="课题组" prop="subject">
					<el-input v-model="ruleForm.subject"></el-input>
				</el-form-item>
				<el-form-item label="电子邮件" prop="email">
					<el-input v-model="ruleForm.email"></el-input>
				</el-form-item>
				<el-form-item label="电话" prop="phone">
					<el-input v-model="ruleForm.phone"></el-input>
				</el-form-item>
				<el-form-item label="内容" prop="content">
					<el-input :autosize="{ minRows: 4, maxRows: 8}" type="textarea" v-model="ruleForm.content"></el-input>
				</el-form-item>
			</el-form>
		</div>
		<div class="jiuwdawd">
			<div v-preventReClick class="laing_btn tijiao" @click="submitForm('ruleForm')">提交</div>
		</div>
	</div>
</template>

<script>
import {chkEmail,chkMobile} from '@/utlis/formrules'
	export default{
		data(){
			return {
				loading:true,
				contact:{},//联系信息
				ruleForm: {
					name: '',//姓名
					unit: '',//单位
					address:'',//地址
					specialty:'',//专业
					subject:'',//课题组
					email:'',//邮箱
					phone:'',//电话
					content:'',//内容
				},
				rules: {
					name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
					unit: [{ required: true, message: '请输入单位', trigger: 'blur' }, ],
					address:{ required: true, message: '请输入地址', trigger: 'blur' },
					specialty:{ required: true, message: '请输入专业', trigger: 'blur' },
					subject:{ required: true, message: '请输入课题组', trigger: 'blur' },
					email:[ { required: true, message: '请输入邮箱', trigger: 'blur' }, { validator: chkEmail, trigger: 'blur' }],
					phone:[{ required: true, message: '请输入电话', trigger: 'blur' },{ validator: chkMobile, trigger: 'blur' }],
					content:{ required: true, message: '请输入内容', trigger: 'blur' }
				}
			}
		},
		created(){
			this.Postcontactpage();
		},
		methods:{
			async Postcontactpage(){
				this.loading = true;
				let {data} = await this.api.Postcontactpage();
				this.contact = data;
				this.loading = false;
			},
			submitForm() {
				this.$refs['ruleForm'].validate(async (valid) => {
				if (!valid) return;
					let {data,code} = await this.api.Postcontact(this.ruleForm);
					if(code==200){
						this.$message({ message: '提交成功', type: 'success' });
						this.resetForm();
					}
				});
			},
			resetForm() {
				this.$refs['ruleForm'].resetFields();
			}
		}
	}
</script>

<style lang="scss" scoped="scoped">
.jiuwdawd{
	width: 665px;
	.tijiao{
		width: 210px;
		height: 40px;
		line-height: 40px;
		margin: 0 auto;
	}
}
	.contact_form{
		width: 655px;
	}
	.tech_titleas{
		font-size: 30px;
		margin-top: 50px;
		
	}
	.contact_box{
		display: flex;
		justify-content: space-between;
	}
	.contact_company{
		color: #666666;
		div{
			line-height: 30px;
		}
		.contact_btn{
			margin-top: 10px;
			width: 150px;
			height: 30px;
			line-height: 30px;
		}
		.asdhju{
			margin: 5px 0;
		}
	}
</style>